import { makeStyles } from '@material-ui/core/styles'

const useStyles = props => makeStyles(theme => {
    return ({
    })
})

export default useStyles
